





























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import PayBillPO from "@/store/entities/finance/paybillspo";

@Component({
  components: {},
})
export default class BillsPay extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  payBill: PayBillPO = new PayBillPO();
  loading: boolean = false;
  display: boolean = false; //支付条码是否显示
  create() {}
  created() {
    this.getItemDetail();
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "paybills/create",
            data: this.payBill,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res.data.result,
        });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.payBill = Util.extend(
        true,
        {},
        this.$store.state.paybills.payBillItems
      );
      this.payBill.payType = 50;
    }
  }
  itemRule = {
    baseUse: [
      {
        required: true,
        type: "number",
        message: this.L("Value") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let pay = detaillist.filter((p) => {
        return p.itemId == 2;
      });
      pay.forEach((ele) => {
        this.$data.paymentType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  changeRadio(val) {
    this.payBill.payType = val;
    if (val != 50) {
      this.display = true;
    } else {
      this.display = false;
    }
  }
  data() {
    return {
      paymentType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
